import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import GlobalStyles from "./components/GlobalStyles";
import Nav from "./components/Nav";
// Import pages down here
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import MovieDetail from "./pages/MovieDetail";

// Animation
import { AnimatePresence } from "framer-motion";
import Subscriptions from "./pages/Subscriptions";
import OurHistory from "./pages/OurHistory";
import OurTeam from "./pages/OurTeam";
import OurCustomerService from "./pages/OurCustomerService";
import OurMenu from "./pages/OurMenu";
import OurGoals from "./pages/OurGoals";
import { useState } from "react";
import TestOrder from "./pages/TestOrder";

function App() {
  const location = useLocation();

  return (
    <div>
      <GlobalStyles />
      <Nav />
      <AnimatePresence exitBeforeEnter>
        <Switch 
          location={location} 
          key={location.pathname}
        >
          <Route path="/" exact>
            <AboutUs />
          </Route>
          <Route path="/history" exact>
            <OurHistory />
          </Route>

          <Route path="/team" exact>
            <OurTeam />
          </Route>

          <Route path="/customer-service" exact>
            <OurCustomerService />
          </Route>

          <Route path="/menu" exact>
            <OurMenu />
          </Route>

          <Route path="/goals" exact>
            <OurGoals />
          </Route>

          <Route path="/contact" exact>
            <ContactUs />
          </Route>
          <Route path="/subspack" exact>
            <Subscriptions />
          </Route>
          <Route path="/work/:id" exact>
            <MovieDetail />
          </Route>

            <Route path="/request-deletion" exact>
            <div style={{ padding: "20px" }}>
              <h2>Request Account Deletion</h2>
              <form
              onSubmit={(e) => {
                e.preventDefault();
                alert(
                "Your account is on pending deletion. You will be notified via SMS."
                );
              }}
              >
              <div style={{ marginBottom: "10px" }}>
                <label htmlFor="phone" style={{ display: "block" }}>
                Phone Number:
                </label>
                <input
                type="tel"
                id="phone"
                name="phone"
                required
                style={{ width: "100%", padding: "8px" }}
                />
              </div>
              <div style={{ marginBottom: "10px" }}>
                <label htmlFor="password" style={{ display: "block" }}>
                Password:
                </label>
                <input
                type="password"
                id="password"
                name="password"
                required
                style={{ width: "100%", padding: "8px" }}
                />
              </div>
              <button
                type="submit"
                style={{
                padding: "10px 20px",
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                cursor: "pointer",
                }}
              >
                Submit
              </button>
              </form>
            </div>
            </Route>

            <Route path="/test-order" exact>
             <TestOrder />
            </Route>
        </Switch>
      </AnimatePresence>
    </div>
  );
}

export default App;
